<template>
    <div v-if="toolboxTalk">
        <header class="bg-gray-100 text-gray-700">
            <div class="w-full mx-auto p-8 lg:p-12 flex flex-col md:flex-row-reverse" style="max-width: 1800px">
                <div class="md:w-72 mb-12 md:mb-0 md:ml-8 lg:ml-12">
                    <img src="https://insync.software/mobile-img/logo.svg" class="h-12">
                    <div class="mt-4">
                        <p class="font-semibold mb-1">Hambro Roofing Limited</p>
                        <p>Unit 2, 6-10 Lamson Road Rainham Essex RM13 9YY</p>
                        <p><a href="tel:01708803930">01708 803 930</a></p>
                        <p><a href="http://www.hambroroofing.com">www.hambroroofing.com</a></p>
                    </div>
                </div>
                <div class="flex-1">
                    <div class="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-8">
                        <div class="text-xl">
                            <h2 class="font-semibold text-gray-700">Date:</h2>
                            <p class="mt-1 text-gray-500">{{ toolboxTalk.formattedDate }}</p>
                        </div>
                        <div class="text-xl">
                            <h2 class="font-semibold text-gray-700">Package:</h2>
                            <p class="mt-1 text-gray-500">{{ toolboxTalk.packageName }}</p>
                        </div>
                        <div class="text-xl col-span-1 sm:col-span-2 ">
                            <h2 class="font-semibold text-gray-700">Toolbox Talk:</h2>
                            <p class="mt-1 text-gray-500">{{ toolboxTalk.reference }} - {{ toolboxTalk.title }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main class="bg-white text-gray-700 pb-8">
            <div class="w-full mx-auto p-8 lg:p-12 lg:pb-16 flex flex-col-reverse lg:flex-row-reverse"
                 style="max-width: 1800px">
                <div class="lg:w-72 lg:mb-0 lg:ml-12 ">
                    <div class="space-y-8 sticky top-4">
                    </div>
                </div>
                <div class="flex-1">
                    <div class="text-xl font-semibold text-gray-900 mt-4">Talk</div>
                    <div class="text-gray-700 whitespace-pre-wrap" v-text="toolboxTalk.talk"></div>
                    <div class="text-xl font-semibold text-gray-900 mt-4">Given By</div>
                    <div class="text-gray-700 whitespace-pre-wrap" v-text="toolboxTalk.givenByName+' ('+toolboxTalk.givenByPosition+')'"></div>
                    <div class="text-xl font-semibold text-gray-900 mt-4">Received By</div>
                    <div class="text-gray-700 whitespace-pre-wrap" v-text="name"></div>
                    <div class="text-xl font-semibold text-gray-900 mt-4">Signed</div>
                </div>
            </div>
            <div class="w-full flex align-middle justify-center" v-if="toolboxTalk.signed">
                <img :src="toolboxTalk.signed" style="max-width:400px; width: 100%" class="border border-gray-200">
            </div>
            <div class="w-full flex align-middle justify-center" v-else>
                <ui-button-new class="align-middle" icon="fas fa-pen" @click="addSignature" primary>Sign {{ toolboxTalk.signed?'again':'' }} as {{ name }}</ui-button-new>
            </div>
        </main>
    </div>
</template>

<script>
import AutoresizableTextarea from "../../../ui/AutoresizableTextarea";
import UiContainer from "../../../ui/UiContainer.vue";
import UiDropdownItem from "../../../ui/UiDropdownItem.vue";
import UiDropdown from "../../../ui/UiDropdown.vue";
import UiButtonNew from "../../../ui/UiButtonNew.vue";
import UiDataGrid from "../../../ui/UiDataGrid.vue";
import UiDataGridItem from "../../../ui/UiDataGridItem.vue";
import UiHeader from "../../../ui/UiHeader.vue";
import Heading from "../../../ui/Heading.vue";

export default {
    components: {
        Heading,
        UiHeader,
        UiDataGridItem,
        UiDataGrid,
        UiButtonNew, UiDropdown, UiDropdownItem, UiContainer, AutoresizableTextarea
    },
    props: {
        toolboxTalk: Object,
        attendeeId: null,
        name: '',
    },
    computed: {},
    data() {
        return {}
    },
    methods: {
        addSignature() {
            this.$modals.sign({
                title: `Sign as "${this.name}"`,
                button: 'Confirmed',
                handle: async (data) => {
                    await Http.post(window.location.href, {signature:data.signature})
                    window.location.reload()
                }
            })
        },
    },
    async mounted() {
    }

}
</script>
